<mat-icon [svgIcon]="'medal_' + medal"></mat-icon>
